module.exports = __webpack_public_path__ + "img/icon-calendar.c3e4ab30.svg";